import { State } from '../rootReducer';

export function getEvents(state: State) {
    return state.event.data;
}

export function isLoading(state: State) {
    return state.event.isLoading;
}
